import SubmitProgressDialog from './ErrorDialog'

export const DIALOG_NAME = 'ERROR_DIALOG'

export default SubmitProgressDialog
